import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
//
import Employees from './employees';
import ErrorPages from './errorPages';
import ErrorPage404 from './errorPages/404';
import HRServices from './HRServices';
import Lms from './lms';
import Main from './main';

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route
        path={`${match.url}main`}
        component={Main}
      />
      <Route
        path={`${match.url}employees`}
        component={Employees}
      />
      <Route
        path={`${match.url}hr`}
        component={HRServices}
      />
      <Route
        path={`${match.url}lms`}
        component={Lms}
      />
      <Route
        path={`${match.url}error-pages`}
        component={ErrorPages}
      />
      <Route path='*' exact component={ErrorPage404} />
    </Switch>
  </div>
);

App.propTypes = {
  match: PropTypes.object
};

export default App;
